import React, { useContext, useEffect, useState } from 'react'
import {
  Container,
  HeaderDiv,
  HeaderText,
  CloseDiv,
  CloseImg,
  ProgressBarDiv,
  ProgressBarCircle,
  ProgressBarLine,
  Phrase,
  ButtonsDiv,
  CancelButton,
  PreviousButtonDiv,
  PreviousButtonImage,
  PreviousButtonText,
  NextButtonDiv,
  NextButtonImage,
  NextButtonText,
  DisabledNextButtonDiv,
  DisabledNextButtonImage,
  DisabledNextButtonText,
} from './style'
import ImportFromExcelContext from '../../../../contexts/ImportFromExcelContext'
import UserContext from '../../../../contexts/UserContext'
import StockContext from '../../../../contexts/StockContext'
import cross from '../../../../assets/addStockModal/cross.svg'
import arrowRight from '../../../../assets/addStockModal/excel/arrow-right.svg'
import arrowLeft from '../../../../assets/addStockModal/excel/arrow-left.svg'
import disabledArrowRight from '../../../../assets/addStockModal/excel/disabled-arrow-right.svg'
import axios from '../../../../config/axios'
import ModalContext from '../../../../contexts/ModalContext'
import { useTenant } from '../../../../contexts/TenantContext'

interface RevisionStepProps {
  isOpen: boolean
  onClose: () => void
}

const RevisionStep = () => {
  const { isFashionTenant } = useTenant()
  const {
    setActiveTab,
    previewSpreadsheet,
    translationMapping,
    manuallyMappedFields,
    updateInOmie,
    setUpdateInOmie,
    calculateLength,
    setCalculateLength,
    calculateWeight,
    setCalculateWeight,
    review,
    setReview,
    setTranslationMapping,
    setLoadingPercentage,
    setImportError,
    setImportResult,
  } = useContext(ImportFromExcelContext)

  console.log('REVISION: Componente montado')
  console.log('REVISION: translationMapping recebido:', translationMapping)
  console.log('REVISION: manuallyMappedFields recebido:', manuallyMappedFields)
  console.log('REVISION: review recebido:', review)
  const { token, user } = useContext(UserContext)
  const { tableFile, setTableFile, setImportFromExcelModal } =
    useContext(StockContext)
  const { setModalActive, setModalSection, isResourceModal } = useContext(ModalContext)
  const isResource =
    isResourceModal ||
    window.location.pathname.includes('/resource') ||
    (previewSpreadsheet &&
      previewSpreadsheet[0] &&
      Object.values(previewSpreadsheet[0]).some((header: any) => {
        const lower = String(header || '').toLowerCase().trim()
        return lower === 'aviamento' || lower === 'insumo' || lower === 'aviamentos' || lower === 'insumos'
      })) ||
    (translationMapping &&
      typeof translationMapping === 'object' &&
      Object.keys(translationMapping).some((key) => {
        const lowerKey = String(key || '').toLowerCase().trim()
        return lowerKey === 'aviamento' || lowerKey === 'insumo' || lowerKey === 'aviamentos' || lowerKey === 'insumos'
      }))

  useEffect(() => {
    console.log(review)
  }, [])

  const handleGoBack = () => {
    console.log('REVISION: handleGoBack chamado')
    console.log('REVISION: translationMapping antes de voltar:', translationMapping)
    console.log('REVISION: manuallyMappedFields antes de voltar:', manuallyMappedFields)
    setModalSection('secondExcelAdd')
  }

  const handleSubmit = () => {
    const formData = new FormData()
    formData.append('file', tableFile[0])

    const storedToken = localStorage.getItem('token') || token
    const resolvedTenantId = user?.tenantId

    const headers: Record<string, any> = {
      'Translation-Mapping': JSON.stringify(translationMapping),
      'Update-in-omie': updateInOmie,
      'Weight-calculate': calculateWeight,
      'Length-calculate': calculateLength,
      'Content-Type': 'multipart/form-data',
    }

    if (isResource) {
      headers['Entity-Type'] = 'RESOURCE'
      headers['Is-Resource'] = 'true'
    }

    if (storedToken) {
      headers['Authorization'] = storedToken.startsWith('Bearer ') ? storedToken : `Bearer ${storedToken}`
    }

    if (resolvedTenantId) {
      headers['x-tenant-id'] = String(resolvedTenantId)
    }

    setImportError(null)
    setImportResult(null)
    setModalSection('fourthExcelAdd')

    axios
      .post(
        `${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/import-from-excel/upload`,
        formData,
        {
          headers,
        },
      )
      .then((res) => {
        console.log(res.data)
        if (res?.data) {
          setImportResult(res.data)
        }
      })
      .catch((err) => {
        console.log(err)
        const errorMessage =
          err?.response?.data?.message ||
          (typeof err?.response?.data === 'string' ? err.response.data : null) ||
          err?.message ||
          'Erro ao processar importação.'
        setImportError(Array.isArray(errorMessage) ? errorMessage.join(', ') : String(errorMessage))
      })
  }

  const handleCancelImport = () => {
    setModalSection('addStockMenu')
    setTableFile(undefined)
    setTranslationMapping({})
    setUpdateInOmie(false)
    setCalculateLength(false)
    setCalculateWeight(false)
    setReview({ missingColumns: [], wrongColumns: [] })
    setImportFromExcelModal(false)
    setLoadingPercentage(0)
    setImportError(null)
    setImportResult(null)
  }

  return (
    <Container>
      <HeaderDiv>
        <HeaderText>
          {isResource
            ? (isFashionTenant ? 'Adicionar aviamento: revisão' : 'Adicionar insumo: revisão')
            : (isFashionTenant ? 'Adicionar tecido: revisão' : 'Importar tabela de estoque: revisão')}
        </HeaderText>
        <CloseDiv onClick={() => setModalActive(false)}>
          <CloseImg src={cross} alt='Close tab' />
        </CloseDiv>
      </HeaderDiv>
      <ProgressBarDiv>
        <ProgressBarCircle className='active' />
        <ProgressBarLine className='active' />
        <ProgressBarCircle className='active' />
        <ProgressBarLine className='active' />
        <ProgressBarCircle className='active' />
      </ProgressBarDiv>
      {review.missingColumns.length === 0 &&
        review.wrongColumns.length === 0 && (
          <Phrase>
            Não foram encontrados erros na planilha ou mapeamento! Clique em
            “Importar” para prosseguir com a importação.
          </Phrase>
        )}

      {review.missingColumns.length !== 0 && (
        <>
          <Phrase>Não foram encontradas as colunas de:</Phrase>
          {review.missingColumns.map((column) => (
            <li key={column}>{column}</li>
          ))}
        </>
      )}

      {review.wrongColumns.length !== 0 && (
        <>
          <Phrase>Existem valores não esperados na coluna:</Phrase>
          {review.wrongColumns.map((column) => (
            <li key={column}>{column}</li>
          ))}
        </>
      )}
      <ButtonsDiv>
        <CancelButton onClick={() => handleCancelImport()}>
          Cancelar
        </CancelButton>
        <PreviousButtonDiv onClick={handleGoBack}>
          <PreviousButtonImage src={arrowLeft} alt='Right arrow icon' />
          <PreviousButtonText>Voltar</PreviousButtonText>
        </PreviousButtonDiv>
        {review.missingColumns.length === 0 &&
        review.wrongColumns.length === 0 ? (
          <NextButtonDiv onClick={() => handleSubmit()}>
            <NextButtonImage src={arrowRight} alt='Right arrow icon' />
            <NextButtonText>Próximo</NextButtonText>
          </NextButtonDiv>
        ) : (
          <DisabledNextButtonDiv>
            <DisabledNextButtonImage
              src={disabledArrowRight}
              alt='Right arrow icon'
            />
            <DisabledNextButtonText>Próximo</DisabledNextButtonText>
          </DisabledNextButtonDiv>
        )}
      </ButtonsDiv>
    </Container>
  )
}

export default RevisionStep

